export const QUICK_BUY = 'quick-buy';
export const QUICK_BUY_LOADING_ICON = 'QuickBuySuccessIcon';
export const QUICK_BUY_OUTLINED_ICON = 'QuickBuyOutlinedIcon';
export const QUICK_BUY_OUTLINED_CN_ICON = 'QuickBuyOutlinedCnIcon';
export const QUICK_BUY_FILLED_ICON = 'QuickBuyFilledIcon';
export const QUICK_BUY_FILLED_CN_ICON = 'QuickBuyFilledCnIcon';
export const QUICK_BUY_BUTTON_STATE_DEFAULT = 'default';
export const QUICK_BUY_BUTTON_STATE_ERROR = 'error';
export const QUICK_BUY_BUTTON_STATE_LOADING = 'loading';
export const QUICK_BUY_BUTTON_STATE_SUCCESS = 'success';
export const QUICK_BUY_BUTTON_STATE_WAITING = 'waiting';
export const ICON_BUTTON_SIZE = 45;
export const ICON_BUTTON_PHONE_SIZE = 35;
export const ICON_BUTTON_SKELETON = 'IconButtonSkeleton';
//# sourceMappingURL=quickBuyButton.js.map